export const getters = {
  getAbsences(state) {
    return state.absences;
  }
}
